import { ComponentTreatmentInfoItemProps } from "api/cms-website";
import { TreatmentInfoItemContent } from "layouts/relaunch/pages/PricesLayout/components/TreatmentInfo";

import { cmsColorEnumToThemePath } from "utils/cmsColorEnumToThemePath";

import { mapImage } from "./mapImage";

export function mapTreatmentInfoItems<
    T extends ComponentTreatmentInfoItemProps
>(items: T[]): TreatmentInfoItemContent[] {
    return items?.map(({ image, bgColor, title, description }) => ({
        title,
        description,
        ...(image
            ? { image: mapImage(image) }
            : {
                  bg:
                      (cmsColorEnumToThemePath(bgColor?.type) as string) ||
                      "bg.base",
              }),
    }));
}
